<template>
  <base-card class="hover:tw-bg-gray-50 " :class="[isClickable ? 'tw-cursor-pointer' : 'tw-cursor-default']">
    <div class="tw-h-full" @click="isClickable && $emit('cardClicked')">
      <div class="tw-flex tw-items-center tw-justify-between">
        <h3 class="tw-text-gray-700 tw-font-thin tw-text-lg tw-whitespace-nowrap">
          {{ title }}
        </h3>

        <!-- Info Icon -->
        <div
          v-if="tooltip && isLocationFiltered && cobrandId === 'rx-harmony'"
          class="tw-relative tw-group tw-ml-2"
          @click.stop
          @mouseenter="$refs.tooltip.show()"
          @mouseleave="$refs.tooltip.hide()"
        >
          <div class="tw-text-gray-400 hover:tw-text-gray-600 tw-cursor-help">
            <information-icon class="tw-h-4 tw-w-4" />
          </div>
          <!-- Tooltip -->
          <base-tooltip ref="tooltip" :textValue="tooltip" />
        </div>
      </div>

      <div v-if="isLoading" class="tw-flex tw-flex-col tw-mt-1">
        <base-skeleton-loader class="tw-h-5 tw-w-12" />
        <base-skeleton-loader class="tw-h-3 tw-w-8 tw-mt-3.5" />
      </div>
      <div v-else>
        <div class="tw-flex tw-flex-col">
          <div class="tw-text-gray-800 tw-text-lg tw-font-medium" :class="countClass">{{ count.toLocaleString() }}</div>
          <div v-if="changeCount" class="tw-flex tw-mt-2">
            <component
              :is="component"
              :class="[changeCount > 0 ? 'tw-text-green-600 tw--rotate-90' : 'tw-text-red-600 tw-rotate-90']"
              class="tw-h-4 tw-w-4 tw-transform tw-my-auto tw--ml-1"
            ></component>
            <div :class="[changeCount > 0 ? 'tw-text-green-600' : 'tw-text-red-600']" class="tw-text-sm">{{ Math.abs(changeCount).toLocaleString() + changeLabel }}</div>
          </div>
          <slot v-else-if="$slots.caption" name="caption"></slot>
          <div v-else-if="caption" class="tw-text-xs tw-font-normal tw-mt-2" :class="captionClass">{{ caption }}</div>
        </div>
      </div>
    </div>
  </base-card>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "SummaryCount",
  components: {
    ArrowRightIcon: () => import("@/assets/svgs/arrow-right-icon.svg"),
    XIcon: () => import("@/assets/svgs/x-icon.svg"),
    InformationIcon: () => import("@/assets/svgs/information-icon.svg"),
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
    ...mapGetters("organization", ["cobrandId"]),
    component() {
      if (this.icon === "arrow-right") return "ArrowRightIcon";
      if (this.icon === "x") return "XIcon";

      return "ArrowRightIcon";
    },
    isClickable() {
      if (this.clickable !== null) return this.clickable;
      return this.title !== "Activities Due" && this.title !== "Total Activities";
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    changeCount: {
      type: Number,
      default: 0,
    },
    changeLabel: {
      type: String,
      default: " this week",
    },
    icon: {
      type: String,
      default: "arrow-right",
    },
    tooltip: {
      type: String,
      default: null,
    },
    countClass: {
      type: String,
      default: "",
    },
    caption: {
      type: String,
      default: "",
    },
    captionClass: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: null,
    },
  },
};
</script>
